import { apiRequest } from './http';
import type { SharePointFavourite, SharePointLocation } from './types';

const favouritesPath = '/api/me/sharepoint-favourites';

export async function listSharePointFavourites(): Promise<SharePointFavourite[]> {
  return apiRequest<SharePointFavourite[]>(favouritesPath);
}

/** Saving the same drive and folder again returns the existing favourite. */
export async function addSharePointFavourite(location: SharePointLocation): Promise<SharePointFavourite> {
  return apiRequest<SharePointFavourite>(favouritesPath, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(location)
  });
}

export async function removeSharePointFavourite(favouriteId: string): Promise<void> {
  await apiRequest<void>(`${favouritesPath}/${encodeURIComponent(favouriteId)}`, { method: 'DELETE' });
}
